import { createFileRoute, redirect } from '@tanstack/react-router'

// The profile hub holds no content of its own — it always lands on the first
// section. Point new sections at their own route file and update the sub-nav.
export const Route = createFileRoute('/(private)/profile/')({
	beforeLoad: () => {
		throw redirect({ to: '/profile/personal', replace: true })
	}
})
